import { render, staticRenderFns } from "./UDP.vue?vue&type=template&id=f9de0ec4&scoped=true&"
import script from "./UDP.vue?vue&type=script&lang=ts&"
export * from "./UDP.vue?vue&type=script&lang=ts&"
import style0 from "./UDP.vue?vue&type=style&index=0&id=f9de0ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9de0ec4",
  null
  
)

export default component.exports